// Split a product name that carries a parenthetical component breakdown,
// e.g. "Glow Blend 70mg Pen Kit (TB-500 10mg · BPC-157 10mg · GHK-Cu 50mg)"
// -> { main: "Glow Blend 70mg Pen Kit", sub: "TB-500 10mg · BPC-157 10mg · GHK-Cu 50mg" }
// Non-blend names return { main: name, sub: null }.
export function splitProductName(name) {
  if (!name) return { main: "", sub: null };
  const m = name.match(/^(.*?)\s*\(([^()]+)\)\s*$/);
  if (!m) return { main: name, sub: null };
  return { main: m[1].trim(), sub: m[2].trim() };
}
